import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
import * as Types from '../../../server/graphql/__generated.types';

const defaultOptions = {} as const;
export type CharacterLimitQueryVariables = Types.Exact<{ [key: string]: never }>;

export type CharacterLimitQuery = {
  __typename?: 'Query';
  user: {
    __typename?: 'User';
    id: string;
    productAccessLimits: {
      __typename?: 'ProductAccessLimits';
      editorCharacterLimit: number;
    };
  };
};

export const CharacterLimitDocument = gql`
  query CharacterLimit {
    user {
      id
      productAccessLimits {
        editorCharacterLimit
      }
    }
  }
`;

/**
 * __useCharacterLimitQuery__
 *
 * To run a query within a React component, call `useCharacterLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useCharacterLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCharacterLimitQuery({
 *   variables: {
 *   },
 * });
 */
export function useCharacterLimitQuery(
  baseOptions?: Apollo.QueryHookOptions<CharacterLimitQuery, CharacterLimitQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CharacterLimitQuery, CharacterLimitQueryVariables>(
    CharacterLimitDocument,
    options
  );
}
export function useCharacterLimitLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CharacterLimitQuery,
    CharacterLimitQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CharacterLimitQuery, CharacterLimitQueryVariables>(
    CharacterLimitDocument,
    options
  );
}
export type CharacterLimitQueryHookResult = ReturnType<typeof useCharacterLimitQuery>;
export type CharacterLimitLazyQueryHookResult = ReturnType<
  typeof useCharacterLimitLazyQuery
>;
export type CharacterLimitQueryResult = Apollo.QueryResult<
  CharacterLimitQuery,
  CharacterLimitQueryVariables
>;
